import Vue from "vue";
import Vuex from "vuex";
//import Cookies from 'js-cookie'
import router from "@/router"
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token:  localStorage.getItem("token")?localStorage.getItem("token"):"",
    realname: localStorage.getItem("realname")?localStorage.getItem("realname"):"",
    username:localStorage.getItem("username")?localStorage.getItem("username"):"",
    user_id: localStorage.getItem("user_id")?localStorage.getItem("user_id"):"",
    usertype: localStorage.getItem("usertype")?localStorage.getItem("usertype"):"",
    userInfo:localStorage.getItem("userInfo")?JSON.parse(localStorage.getItem("userInfo")):{},
    piduserinfo:localStorage.getItem("piduserinfo")?JSON.parse(localStorage.getItem("piduserinfo")):{}
  },
  // 更改 Vuex 的 store 中的状态的唯一方法是提交 mutation
  mutations: {
    changeJobList(state, jobList) {
      state.joblist = jobList;
    },
    // 登录成功，记录登录账户信息
    login(state, loginInfo) {
      state.token = loginInfo.userInfo.token;
      localStorage.setItem("token", loginInfo.userInfo.token);

      state.realname = loginInfo.userInfo.realname;
      localStorage.setItem("realname", loginInfo.userInfo.realname);

      state.username = loginInfo.userInfo.username;
      localStorage.setItem("username", loginInfo.userInfo.username);

      state.user_id = loginInfo.userInfo.user_id;
      localStorage.setItem("user_id", loginInfo.userInfo.user_id);

      state.usertype = loginInfo.userInfo.usertype;
      localStorage.setItem("usertype", loginInfo.userInfo.usertype);

       state.userInfo = loginInfo.userInfo;
      localStorage.setItem("userInfo", JSON.stringify(loginInfo.userInfo));

      state.piduserinfo = loginInfo.piduserinfo;
      localStorage.setItem("piduserinfo", JSON.stringify(loginInfo.piduserinfo));

    },
    // 退出登录，清除账户的状态记录
    logout (state){
      state.token = "";
      localStorage.clear();
      router.push('/')
    }

  },
  // 获取值得方式之一，方便加一些筛选项
  getters: {

  },

  actions: {},
  modules: {},
});
